import Vue from 'vue'
import CoolguaContainer from './container'

Vue.component('coolgua-container', CoolguaContainer)


import seeMoreAndTitleRow from './seeMoreAndTitleRow.vue'

Vue.component('seeMoreAndTitleRow', seeMoreAndTitleRow)

import videoImageWrapper from './videoImageWrapper.vue'

Vue.component('videoImageWrapper', videoImageWrapper)

import mfooter from './mfooter.vue'

Vue.component('mfooter', mfooter)

import indexTitle2 from './indexTitle2.vue'

Vue.component('indexTitle2', indexTitle2)

import indexTitle from './indexTitle.vue'

Vue.component('indexTitle', indexTitle)


import exhibitionItem from './exhibitionItem.vue'

Vue.component('exhibitionItem', exhibitionItem)


import messageButton from './messageButton.vue'

Vue.component('messageButton', messageButton)

import meHeader from './meHeader/index'

Vue.component('meHeader', meHeader)

import nullComponent from './nullComponent'

Vue.component('nullComponent', nullComponent)
Vue.component('nullComponent1', nullComponent)

import likeButton from './likeButton'
Vue.component('likeButton', likeButton)

import collectButton from './collectButton.vue'
Vue.component('collectButton', collectButton)

import tagList from "./tagList"

Vue.component('tagList', tagList)

import inviteButton from "./inviteButton.vue"

Vue.component('inviteButton', inviteButton)


// import VueAwesomeSwiper from 'vue-awesome-swiper'

// Vue.use(window.VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(window.VueAwesomeSwiper)

import returnBackButton from "./returnBackButton.vue"

Vue.component('returnBackButton', returnBackButton)


import jsonDiv from "./jsonDiv.vue"

Vue.component('jsonDiv', jsonDiv)
Vue.component('jsondiv', jsonDiv)

import videoCallButton from "./videoCallButton.vue"

Vue.component('videoCallButton', videoCallButton)






// WEBPACK FOOTER //
// ./src/wenxing/components/gComponent.js